import { MatchDetailVm } from './api';

export const externalMatchSources = (match: Pick<MatchDetailVm,
    'hungaryGameId' | 'eurocupMatchKey' | 'championsLeagueMatchKey' | 'microplusMatchKey'>): string[] => [
    match.hungaryGameId ? `Hungary game ${match.hungaryGameId}` : undefined,
    match.eurocupMatchKey ? `Euro Cup (legacy, historical seasons) ${match.eurocupMatchKey}` : undefined,
    match.championsLeagueMatchKey ? `Champions League (legacy, historical seasons) ${match.championsLeagueMatchKey}` : undefined,
    match.microplusMatchKey ? `European Aquatics (Microplus) ${match.microplusMatchKey}` : undefined,
].filter((label): label is string => !!label);
